import React, { useEffect, useRef, useState } from 'react';
import '../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { selectPressRegPro, selectTrimData } from '../Selectors/StitchSelector/StitchingSelectors';
import { fetchPressRegProduction } from '../../Store/PHPSlice/Press/PressingApi';
import FirmHeaderImg from '../FieldsComponents/FirmHeaderImg';


const PressInfo = () => {
    const [formData, setFormData] = useState({
        dt: '',
        prMemo: '',
        trnMemo: '',
        empNm: '',
        itemNm: '',
        sono: '',
        soId: '',
        mcloth: '',
        mclothNm: '',
        m1cloth: '',
        m1clothNm: '',
        m2cloth: '',
        m2clothNm: '',
        m3cloth: '',
        m3clothNm: '',
        totqty: '',
        instruction: '',
        firmId: ''
    });
    const { Id } = useParams();
    const dispatch = useDispatch();
    const presslist = useSelector(selectPressRegPro);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    // console.log(presslist.data)
    useEffect(() => {
        dispatch(fetchPressRegProduction(Id))
    }, [Id, dispatch]);
   useEffect(() => {
    if (presslist?.data?.length > 0) {

        const item = presslist.data[0]; // <-- FIX

        console.log("Press Item:", item);

        setFormData(prev => ({
            ...prev,
            dt: item.dt || '',
            prMemo: item.prMemo || '',
            trnMemo: item.trnMemo || '',
            totqty: item.totQty || item.totqty || '',
            instruction: item.instruction || '',
            empNm: item.empNm || '',
            itemNm: item.itemNm || '',
            soId: item.soId || '',
            sono: item.sono || '',
            mcloth: item.mcloth || '',
            mclothNm: item.mclothNm || '',
            m1cloth: item.m1cloth || '',
            m1clothNm: item.m1clothNm || '',
            m2cloth: item.m2cloth || '',
            m2clothNm: item.m2clothNm || '',
            m3cloth: item.m3cloth || '',
            m3clothNm: item.m3clothNm || '',
            firmId: item.firmId || '',
            orderType:item.orderType||'',
            kjMemo:item.kjMemo || ''
        }));
    }
}, [presslist]);


    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };



    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>
                        {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />}
                        <h3 className='centered-heading'>Pressing Info</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.dt}</td>

                                    <td style={{ width: '200px' }}>Order Type</td>
                                 
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{(formData.orderType === 'kaje' ? 'Kaje Return Memo No Wise':' Direct Sale Order No Wise')}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Iron Memo No.</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.prMemo}</td>

                                    <td style={{ width: '200px' }}>Kaje Inward Memo No.</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.kjMemo}</td>

                                </tr>

                                {formData.soId !== '0' &&

                                    <tr>
                                        <td style={{ width: '200px' }}>Sale Order No.</td>

                                        <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sono}</td>

                                    </tr>
                                }
                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Item</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.itemNm}</td>


                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Issue Qty.</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.totqty}</td>
                                </tr>

                            </tbody>
                        </table>
                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>


                                <tr>
                                    <td style={{ width: '100px' }}>Main Cloth</td>

                                    <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.mclothNm}</td>

                                </tr>

                                {formData.m1cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-1</td>

                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m1clothNm}</td>
                                    </tr>
                                }

                                {formData.m2cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-2</td>

                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m2clothNm}</td>
                                    </tr>
                                }

                                {formData.m3cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-3</td>

                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m3clothNm}</td>
                                    </tr>
                                }


                            </tbody>

                        </table>
                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>
                                <tr>

                                    <td style={{ width: '200px' }}>Iron Instructions</td>

                                    <td style={{ width: '800px', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.instruction}</td>

                                </tr>
                            </tbody>
                        </table>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <thead>
                                <th>Size</th>
                                <th>Given Qty</th>
                                <th>Issue Qty</th>
                                {/* <th>Bal Qty</th> */}
                            </thead>
                            <tbody>
                                {presslist?.Info?.map((item, index) => (
                                    <tr key={index}>
                                       <td>{item.size}</td>
                                        <td>{item.qty}</td>
                                        <td>{item.issqty}</td>
                                        {/* <td>{item.balqty}</td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default PressInfo;
